import { render, staticRenderFns } from "./ShippingLabelShipment.vue?vue&type=template&id=4aa57b3a&"
import script from "./ShippingLabelShipment.vue?vue&type=script&lang=js&"
export * from "./ShippingLabelShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports